// @flow
export type Model = any;

export const createModel = (): Model => ({
  // empty redux state
});
